import { TourProvider } from '@reactour/tour';
import { isMobile } from "react-device-detect";
import useGeneralContext from '../../context/GeneralContext';

const styles = {
    popover: (base) => ({
        ...base,
        backgroundColor: "var(--bg-12)",
        color: "var(--text-3)",
        fontSize: !isMobile ? 14 : 'inherit',
        fontWeight: 500,
        padding: 20,
        paddingTop: 32,
        borderRadius: 6,
        top: !isMobile ? 20 : 10,
        maxWidth: !isMobile ? 320 : 353,
        boxShadow: "var(--shadow-reactour)",
    }),
    navigation: (base) => ({
        ...base,
    }),
    badge: (base) => ({
        ...base,
        display: 'none'
    }),
    close: (base) => ({
        ...base,
        top: 12,
        right: 12,
        color: "var(--text-1)",
    }),
};

function Badge() {
    return null;
}

function nextStep({ currentStep, stepsLength, setIsOpen, setCurrentStep, steps }) {
    const last = currentStep === stepsLength - 1
    if (last) {
        setIsOpen(false)
    } else {
        setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
    }
}

function NextButton({ currentStep, stepsLength, setIsOpen, setCurrentStep, steps }) {
    const { tourStart } = useGeneralContext();

    return (
        <button
            onClick={() => nextStep({ currentStep, stepsLength, setIsOpen, setCurrentStep, steps })}
            className="btn btn-primary btn-sm"
            style={{ padding: '6px 12px', minHeight: 'auto', borderRadius: 4, fontSize: 12, marginLeft: 'auto' }}>
            { tourStart ? 'Próximo' : 'Finalizar' }
        </button>
    )
}

function PrevButton({ currentStep, stepsLength, setIsOpen, setCurrentStep, steps }) {
    const first = currentStep === 0
    const { disablePrev } = useGeneralContext();
    if (disablePrev) {
        return null;
    }
    return (
        <button
            onClick={() => {
                if (first) {
                    setCurrentStep(() => steps.length - 1)
                } else {
                    setCurrentStep((s) => s - 1)
                }
            }}
            className="btn btn-primary btn-sm"
            style={{ padding: '6px 12px', minHeight: 'auto', borderRadius: 4, fontSize: 12, }}>
            Anterior
        </button>
    )
}

const TourWrapper = ({ children }) => {

    const { showTourButtons, setTourStart } = useGeneralContext();

    return (
        <TourProvider
            steps={[]}
            styles={styles}
            disableDotsNavigation
            showDots={false}
            components={{ Badge }}
            showCloseButton={false}
            nextButton={NextButton}
            prevButton={PrevButton}
            scrollSmooth
            onClickClose={({ setIsOpen, setSteps }) => {
                setSteps([]);
                setTourStart(false);
                if (setIsOpen) {
                    setIsOpen(false);
                }
            }} showPrevNextButtons={showTourButtons}
            disableInteraction={!showTourButtons}
            onClickHighlighted={(e, props) => {
                e.stopPropagation();
                e.preventDefault();
                nextStep(props)
            }}
            onClickMask={() => null}
        >
            {children}
        </TourProvider>
    )
}

export default TourWrapper;